export interface DeviceFingerprint {
    screen_size: string
    color_depth: number
    timezone: string
    language: string
}

let cachedFingerprint: DeviceFingerprint | null = null

export const getDeviceFingerprint = (): DeviceFingerprint => {
    if (cachedFingerprint === null) {
        cachedFingerprint = {
            screen_size: `${window.screen.width}x${window.screen.height}`,
            color_depth: window.screen.colorDepth,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            language: navigator.language,
        }
    }
    return cachedFingerprint
}
